export function Subscribe(store, stateKey, reactive = true) {
    return function (prototype, propertyName) {
        prototype.storeManager || (prototype.storeManager = { pending: [] });
        prototype.storeManager.pending.push([
            store,
            stateKey || propertyName,
            propertyName,
            reactive,
        ]);
    };
}
//# sourceMappingURL=decorators.js.map